// Lightweight first-party analytics — sends events to our FastAPI backend.
// Visitor ID persists in localStorage (∞), session ID in sessionStorage (tab).
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const uuid = () =>
  (crypto?.randomUUID && crypto.randomUUID()) ||
  Math.random().toString(36).slice(2) + Date.now().toString(36);

const VID_KEY = "kl_visitor_id";
const SID_KEY = "kl_session_id";

export const getVisitorId = () => {
  let v = localStorage.getItem(VID_KEY);
  if (!v) {
    v = uuid();
    localStorage.setItem(VID_KEY, v);
  }
  return v;
};

export const getSessionId = () => {
  let s = sessionStorage.getItem(SID_KEY);
  if (!s) {
    s = uuid();
    sessionStorage.setItem(SID_KEY, s);
  }
  return s;
};

const post = (path, body) =>
  axios.post(`${API}${path}`, body).catch(() => {});

export const trackPageview = (path = window.location.pathname) =>
  post("/events/pageview", {
    path,
    referrer: document.referrer || "",
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
  });

export const trackEvent = (name, props = {}) =>
  post("/events/track", {
    name,
    path: window.location.pathname,
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    props,
  });
